export default "__VITE_ASSET__CUPlR5Zz__"